module.exports = __webpack_public_path__ + "img/13.a4d9c9a0.svg";